import cn from 'classnames';
import { useEffect, useState } from 'react';
import './FiltersPanelGoogleBrandHealth.scss';
import { InteractiveDiv } from '../../Components/InteractiveEl';

interface FiltersPanelGoogleBrandHealthProps {
  regionMap: Partial<Record<string, boolean>>;
  setRegionMap: (key: string, value: boolean) => void;
}

export const FiltersPanelGoogleBrandHealth = ({
  regionMap,
  setRegionMap
}: FiltersPanelGoogleBrandHealthProps) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => setInnerHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  let spacingClass: string | undefined;
  if (innerHeight < 972 && innerHeight >= 888) {
    spacingClass = 'reduce-spacing-1';
  } else if (innerHeight < 888 && innerHeight >= 804) {
    spacingClass = 'reduce-spacing-2';
  } else if (innerHeight < 804 && innerHeight >= 720) {
    spacingClass = 'reduce-spacing-3';
  } else if (innerHeight < 720) {
    spacingClass = 'wrap';
  }

  return (
    <div className='filters-panel-google-brand-health'>
      <div className={cn('filters', spacingClass)}>
        <div className={cn('filter-section', spacingClass)}>
          <div className='filter-name'>Region</div>
          <div className='filter-options'>
            <CheckBox
              checked={regionMap['Region-All'] || false}
              label='All'
              onCheck={() => {
                setRegionMap('Region-All', !regionMap['Region-All']);
                setRegionMap('Northeast', false);
                setRegionMap('South', false);
                setRegionMap('Midwest', false);
                setRegionMap('West', false);
              }}
            />
            <CheckBox
              checked={regionMap.Northeast || false}
              label='Northeast'
              onCheck={() => {
                setRegionMap('Northeast', !regionMap.Northeast);
                setRegionMap('Region-All', false);
              }}
            />
            <CheckBox
              checked={regionMap.South || false}
              label='South'
              onCheck={() => {
                setRegionMap('South', !regionMap.South);
                setRegionMap('Region-All', false);
              }}
            />
            <CheckBox
              checked={regionMap.Midwest || false}
              label='Midwest'
              onCheck={() => {
                setRegionMap('Midwest', !regionMap.Midwest);
                setRegionMap('Region-All', false);
              }}
            />
            <CheckBox
              checked={regionMap.West || false}
              label='West'
              onCheck={() => {
                setRegionMap('West', !regionMap.West);
                setRegionMap('Region-All', false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

interface CheckBoxProps {
  checked: boolean;
  label: string;
  onCheck: (key: string, value: boolean) => void;
}

const CheckBox = ({ checked, label, onCheck }: CheckBoxProps) => (
  <div className='checkbox-container'>
    <InteractiveDiv
      className={cn('checkbox', { checked })}
      onClick={() => onCheck(label, !checked)}
    />
    <div className={cn('label', { checked })}>{label}</div>
  </div>
);
